<template lang="pug">
  .container.grid-xl
    .card.mt-2
      .card-header
        .text-bold Filtrar
      .card-body
        form-filter(@submit="fetchReport")
    .full-height.loading.loading-lg(v-if="loading")
    div(v-if="report")
      div(v-if="Object.values(report.data).length")
        .card.my-2
          .card-header
            .h5 Tabela resumo
          .card-body.table-scroll
            table.table.table-striped.table-scroll.table-hover
              thead
                tr
                  th {{ 'doc.modelo' | tModel }}
                  th.text-right(v-for="coluna in report.colunas") {{ coluna }}
              tbody
                tr(v-for="item, modelo in report.data")
                  td
                    .text-ellipsis(style="width: 400px") {{ modelo }}
                  td.text-right(v-for="col in item")
                    div
                      small Quantidade: #[span.text-bold {{ col.q }}]
                    div
                      small Valor: #[span.text-bold {{ col.valor_total | currency('R$ ')}}]
              tfoot
                tr
                  th Total
                  th.text-right(v-for="col in totais")
                    div
                      small Quantidade: #[span.text-bold {{ col.q }}]
                    div
                      small Valor: #[span.text-bold {{ col.valor_total | currency('R$ ')}}]
      .card.mt-2(v-else)
        .card-body
          .empty
            .empty-icon
              i.fa.fa-search.fa-4x
            p.empty-title.h5 Nada encontrado
            p.empty-subtitle Não foram encontradas Notificações neste período
</template>

<script>
import { deepKey } from 'paliari-js-utils'
import toastErrors from '@/lib/errors/toastErrors'
import notificacoes from '@/api/indicadores/docs'
import FormFilter from './components/Filter'

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  components: { FormFilter },
  computed: {
    totais() {
      if (!deepKey(this.report, 'data') || !deepKey(this.report, 'colunas'))
        return []
      const soma = {}
      Object.values(this.report.colunas).forEach(coluna => {
        soma[coluna] = { q: 0, valor_total: 0 }
      })
      Object.values(this.report.data).forEach(data => {
        Object.keys(data).forEach(coluna => {
          soma[coluna].q += Number(data[coluna].q)
          soma[coluna].valor_total += Number(data[coluna].valor_total)
        })
      })

      return Object.values(soma)
    },
  },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await notificacoes.valorMensal({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>
